import FItem from '../FItem';
import component from './component.vue';

export default class FSelect extends FItem {
  __component = component;

  constructor(props) {
    super(props);
    this.options = props.options || [];
    this.__multiple = !!props.multiple;
    this.__clearable = !!props.clearable;
  }

  get clearable() {
    return !(!this.__clearable || this.required);
  }

  set clearable(value) {
    this.__clearable = !!value;
  }

  get multiple() {
    return this.__multiple;
  }

  set multiple(value) {
    this.__multiple = !!value;
  }

  get data() {
    if (this.multiple) {
      return {
        [this.__name]: this.__value ? this.__value.map(i => i?.value || i) : [],
      };
    }
    return {
      [this.__name]: this.__value ? this.__value.value : null,
    };
  }

  set(value) {
    if (this.multiple) {
      super.set(value || []);
    } else {
      super.set(value || null);
    }
  }

  setValidatorRequire(message = 'Обязательное') {
    this.setValidator((value) => {
      if (this.multiple && Array.isArray(value)) {
        return Promise.reject(message);
      }
      if (!this.multiple && !value) {
        return Promise.reject(message);
      }
      return Promise.resolve();
    }, true);
    return this;
  }

  toString() {
    return this.value?.label || '';
  }

  toValue() {
    if (this.value?.value === 0) {
      return 0;
    }
    return this.value?.value || null;
  }

  toLabel() {
    if (!this.value) {
      return '';
    }
    if (this.value.label) {
      return this.value.label;
    }
    const item = this.options.find(i => i.value === this.value.value);
    if (item) {
      return item.label;
    }
    return '';
  }
}
